import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Accordion, Form, Row, Col, Button, Modal, } from 'react-bootstrap';
import IconButton from 'components/common/IconButton';
import Divider from 'components/common/Divider';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { Axios } from 'helpers/axios';
import HabilitationService from 'services/habilitationsService';

import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { formStructureModifier, formCreerClient } from 'helpers/yupValidationSchema';

import NoStructure from './noStructure';
import LoaderInfiniteLoop from 'widgets/loaderInfiniteLoop';
import MyAdvancedTable from 'components/common/myAdvancedTable/myAdvancedTable';
import FalconCloseButton from 'components/common/FalconCloseButton';

const FormOneStructure = ({
    structure,
}) => {
    const [isLoading, setIsLoading] = useState(false);
    const { register, handleSubmit, formState: { errors }, setValue, } = useForm({
        resolver: yupResolver(formStructureModifier),
    });

    const updateStructure = async (data) => {
        try {
            setIsLoading(true);
            const response = await Axios.post('/authenticatedRoutes/structures/updateStructure',{
                idStructureClient: structure.idStructureClient,
                ...data
            });
            HabilitationService.saveCompleteSet({...response.data, seSouvenir: HabilitationService.seSouvenir});
            location.reload();
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(()=>{
        setValue("nomStructureClient", structure.nomStructureClient);
        setValue("adresseStructureClient", structure.adresseStructureClient);
        setValue("representantLegalStructureClient", structure.representantLegalStructureClient);
        setValue("representantLegalFonctionStructureClient", structure.representantLegalFonctionStructureClient);
        setValue("representantLegalMailStructureClient", structure.representantLegalMailStructureClient);
        setValue("representantLegalTelStructureClient", structure.representantLegalTelStructureClient);
        setValue("facturationMailStructureClient", structure.facturationMailStructureClient);
        setValue("facturationTelStructureClient", structure.facturationTelStructureClient);
    },[])

    return(<>
        <Form onSubmit={handleSubmit(updateStructure)}>
            <Row>
                <Col md={6}>
                    <Form.Group className="mb-3">
                        <Form.Label>Raison sociale <small>(Nom de l'association, entreprise, club)</small></Form.Label>
                        <Form.Control size="sm" type="text" name="nomStructureClient" id="nomStructureClient" {...register('nomStructureClient')} isInvalid={!!errors.nomStructureClient}/>
                        <small className="text-danger">{errors.nomStructureClient?.message}</small>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-2">
                        <Form.Label>Adresse complète</Form.Label>
                        <Form.Control as="textarea" rows={4} name="adresseStructureClient" id="adresseStructureClient" {...register("adresseStructureClient")}  isInvalid={!!errors.adresseStructureClient}/>
                        <small className="text-danger">{errors.adresseStructureClient?.message}</small>
                    </Form.Group>
                </Col>

                <Divider>Représentant légal</Divider>

                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Représentant Légal <small>Nom, Prénom</small></Form.Label>
                        <Form.Control type="text" name="representantLegalStructureClient" id="representantLegalStructureClient" {...register("representantLegalStructureClient")} isInvalid={!!errors.representantLegalStructureClient}/>
                        <small className="text-danger">{errors.representantLegalStructureClient?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Fonction</Form.Label>
                        <Form.Control type="text" name="representantLegalFonctionStructureClient" id="representantLegalFonctionStructureClient" {...register("representantLegalFonctionStructureClient")} isInvalid={!!errors.representantLegalFonctionStructureClient}/>
                        <small className="text-danger">{errors.representantLegalFonctionStructureClient?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Adresse email</Form.Label>
                        <Form.Control type="text" name="representantLegalMailStructureClient" id="representantLegalMailStructureClient" {...register("representantLegalMailStructureClient")} isInvalid={!!errors.representantLegalMailStructureClient}/>
                        <small className="text-danger">{errors.representantLegalMailStructureClient?.message}</small>
                    </Form.Group>
                </Col>
                <Col md="6">
                    <Form.Group className="mb-2">
                        <Form.Label>Téléphone</Form.Label>
                        <Form.Control type="text" name="representantLegalTelStructureClient" id="representantLegalTelStructureClient" {...register("representantLegalTelStructureClient")} isInvalid={!!errors.representantLegalTelStructureClient}/>
                        <small className="text-danger">{errors.representantLegalTelStructureClient?.message}</small>
                    </Form.Group>
                </Col>

                <Divider>Facturation</Divider>

                <Col md={6}>
                    <Form.Group className="mb-2">
                        <Form.Label>Adresse email pour la facturation</Form.Label>
                        <Form.Control type="text" name="facturationMailStructureClient" id="facturationMailStructureClient" {...register("facturationMailStructureClient")} isInvalid={!!errors.facturationMailStructureClient}/>
                        <small className="text-danger">{errors.facturationMailStructureClient?.message}</small>
                    </Form.Group>
                </Col>
                <Col md={6}>
                    <Form.Group className="mb-2">
                        <Form.Label>Téléphone du contact pour la facturation</Form.Label>
                        <Form.Control type="text" name="facturationTelStructureClient" id="facturationTelStructureClient" {...register("facturationTelStructureClient")} isInvalid={!!errors.facturationTelStructureClient}/>
                        <small className="text-danger">{errors.facturationTelStructureClient?.message}</small>
                    </Form.Group>
                </Col>
            </Row>
            <Button variant='primary' className='mt-3 mb-1 w-100' type="submit" disabled={isLoading}>{isLoading ? 'Patientez...' : 'Enregistrer'}</Button>
        </Form>
    </>)
}

const UsersOneStructure = ({
    structure,
}) =>{
    const [isLoading, setIsLoading] = useState(false);
    
    const colonnes = [
        {
            accessorKey: 'idClient',
            header: '#',
        },
        {
            accessorKey: 'nomClient',
            header: 'Compte',
            cell: ({ row }) => {
                return(row.original.nomClient + ' ' + row.original.prenomClient);
            },
        },
        {
            accessorKey: 'mailClient',
            header: 'Mail (identifiant de connexion)',
        },
        {
            accessorKey: 'idClient',
            header: 'Action',
            cell: ({ row }) => {
                return(<>
                    <IconButton
                        size='sm'
                        variant='outline-danger'
                        icon='person-walking-dashed-line-arrow-right'
                        disabled={HabilitationService.habilitations.idClient == row.original.idClient}
                        onClick={()=>{handleShowDeleteModal(row.original.idClient)}}
                    >Revoquer l'accès à la structure</IconButton>
                </>);
            },
        },
    ];

    //DELETE USER
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [idClientModal, setIdClientModal] = useState();
    const handleShowDeleteModal = (idClient) => {
        setShowDeleteModal(true);
        setIdClientModal(idClient);
    }
    const handleCloseDeleteModal = () => {
        setShowDeleteModal(false);
        setIdClientModal();
    }
    const dropHabilitation = async () => {
        try {
            setIsLoading(true);

            await Axios.post('/authenticatedRoutes/structures/dropClientSturcture',{
                idStructureClient: structure.idStructureClient,
                idClient: idClientModal,
            });

            location.reload();
        } catch (error) {
            console.error(error)
        }
    }

    //INVITE USER
    const [showInviteModal, setShowInviteModal] = useState(false);
    const { register, handleSubmit, formState: { errors }, } = useForm({
        resolver: yupResolver(formCreerClient),
    });
    const handleShowInviteModal = () => {
        setShowInviteModal(true);
    }
    const handleCloseInviteModal = () => {
        setShowInviteModal(false);
    }
    const inviteUser = async (data) => {
        try {
            setIsLoading(true);

            await Axios.post('/authenticatedRoutes/structures/inviteUserToStructure',{
                idStructureClient: structure.idStructureClient,
                ...data
            });

            location.reload();
        } catch (error) {
            console.error(error)
        }
    }

    return (<>
        <MyAdvancedTable
            columns={colonnes}
            data={structure.users}
            topButtonShow={true}
            topButton={<IconButton
                size='sm'
                icon='plus'
                variant='outline-success'
                onClick={handleShowInviteModal}
            >Inviter un utilisateur</IconButton>}
        />

        <Modal show={showDeleteModal} onHide={handleCloseDeleteModal} backdrop="static" keyboard={false}>
            <Modal.Header>
                <Modal.Title className='text-danger'>SUPPRESSION D'HABILITATION</Modal.Title>
                <FalconCloseButton onClick={handleCloseDeleteModal}/>
            </Modal.Header>
            <Modal.Body>
                Attention, vous êtes sur le point de supprimer les habilitations de ce compte à la structure <b>{structure.nomStructureClient}</b>. Etes-vous sur de vouloir continuer ?
            </Modal.Body>
            <Modal.Footer>
                <Button variant="danger" onClick={dropHabilitation} disabled={isLoading}>
                    {isLoading ? "Chargement ..." : "Je confirme la suppression"}
                </Button>
                <Button variant="secondary" onClick={handleCloseDeleteModal}>
                    Annuler
                </Button>
            </Modal.Footer>
        </Modal>

        <Modal show={showInviteModal} onHide={handleCloseInviteModal} backdrop="static" keyboard={false} size='lg'>
            <Modal.Header>
                <Modal.Title>Inviter un utilisateur</Modal.Title>
                <FalconCloseButton onClick={handleCloseInviteModal}/>
            </Modal.Header>
            <Modal.Body>
                <p>Veuillez saisir les informations de l'utilisateur que vous souhaitez inviter à <b>{structure.nomStructureClient}</b></p>
                <Form onSubmit={handleSubmit(inviteUser)}>
                    <Row>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Nom</Form.Label>
                                <Form.Control size="sm" type="text" name="nomClient" id="nomClient" {...register('nomClient')} isInvalid={!!errors.nomClient}/>
                                <small className="text-danger">{errors.nomClient?.message}</small>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Prénom</Form.Label>
                                <Form.Control size="sm" type="text" name="prenomClient" id="prenomClient" {...register('prenomClient')} isInvalid={!!errors.prenomClient}/>
                                <small className="text-danger">{errors.prenomClient?.message}</small>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Mail</Form.Label>
                                <Form.Control size="sm" type="email" name="mailClient" id="mailClient" {...register('mailClient')} isInvalid={!!errors.mailClient}/>
                                <small className="text-danger">{errors.mailClient?.message}</small>
                            </Form.Group>
                        </Col>
                        <Col md={6}>
                            <Form.Group className="mb-3">
                                <Form.Label>Téléphone</Form.Label>
                                <Form.Control size="sm" type="text" name="telClient" id="telClient" {...register('telClient')} isInvalid={!!errors.telClient}/>
                                <small className="text-danger">{errors.telClient?.message}</small>
                            </Form.Group>
                        </Col>
                    </Row>
                    <Form.Group className="mb-3">
                        <Button className="w-100" type="submit" disabled={isLoading} variant='primary'>{isLoading ? 'Chargement ...':"Inviter"}</Button>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseInviteModal}>
                    Annuler
                </Button>
            </Modal.Footer>
        </Modal>
        
    </>)
}

const MesStructures = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [structures, setStructures] = useState([]);

    const initPage = async () => {
        try {
            const response = await Axios.get('/authenticatedRoutes/structures/getStructuresOneUser');
            setStructures(response.data);
            setIsLoading(false);
        } catch (error) {
            console.error(error)
        }
    }

    useEffect(()=>{
        initPage();
    },[])

    if(isLoading)
    {
        return <LoaderInfiniteLoop />
    }else{
        return (<>
            {structures.length == 0 ?
                <NoStructure />
            :
                <>
                    <Accordion defaultActiveKey={0}>
                        {structures.map((structure, i)=>{return(
                            <Accordion.Item key={i} eventKey={i}>
                                <Accordion.Header>{structure.nomStructureClient}</Accordion.Header>
                                <Accordion.Body>

                                    <Accordion>
                                        <Accordion.Item eventKey={0}>
                                            <Accordion.Header><FontAwesomeIcon icon='clipboard-list' className='me-2'/> Propriétés</Accordion.Header>
                                            <Accordion.Body>
                                                <FormOneStructure
                                                    structure={structure}
                                                />
                                            </Accordion.Body>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey={1}>
                                            <Accordion.Header><FontAwesomeIcon icon='users' className='me-2'/> Utilisateurs</Accordion.Header>
                                            <Accordion.Body>
                                                <UsersOneStructure
                                                    structure={structure}
                                                />
                                            </Accordion.Body>
                                        </Accordion.Item>
                                    </Accordion>
                                    
                                </Accordion.Body>
                            </Accordion.Item>
                        )})}
                        <Accordion.Item eventKey={"add"}>
                            <Accordion.Header>Ajouter une structure</Accordion.Header>
                            <Accordion.Body>
                                Vous faites partie d'une autre structure et souhaitez gérer ces multiples sturctures depuis cette même interface ?<br/>
                                <center><IconButton variant='outline-primary' icon='envelope' size='sm' className='mt-3' as={Link} to='/contact'> Faites nous en la demande</IconButton></center>
                            </Accordion.Body>
                        </Accordion.Item>
                    </Accordion>
                </>
            }
        </>);
    }
    
};

export default MesStructures;